export default "__VITE_ASSET__BHl1ohL4__"